import React, { useState, useContext } from 'react';
import { HandleDeletePerson } from './requests/PersonRequests';
import { DataContext } from '../../stores/crm-person-store';
import GenericDeleteDetailsDropdownModal from './shared/GenericDeleteDetailsDropdownModal';
import { navigate } from 'hookrouter';
import { CalculateSettings } from '../crm/shared/Functions';

const PersonDetailsDropdownModal = () => {
    const [, setShow] = useState(false);

    const {
        store: { activePerson, rows, requestObject, viewSettings },
        dispatch,
    } = useContext(DataContext);

    const updateStoreAfterDelete = () => {
        const indexToDelete = rows.findIndex((p) => p.id === activePerson.id);
        if (indexToDelete >= 0) {
            rows.splice(indexToDelete, 1);
            requestObject.amount -= 1;
            const newViewSettings = CalculateSettings(viewSettings, requestObject);
            dispatch({ type: 'UPDATE_DATA', payload: rows });
            dispatch({ type: 'UPDATE_VIEW_SETTINGS_AND_REQUEST_OBJECT', viewSettings: newViewSettings, requestObject: requestObject });
        }
    };

    const deletePerson = async () => {
        const response = await HandleDeletePerson(activePerson.id);
        if (response.success) {
            setShow(false);
            updateStoreAfterDelete();
            navigate('/crmPersons');
            dispatch({
                type: 'UPDATE_ACTIVE_PERSON',
                payload: response.person,
            });
        }
        return response;
    };

    return (
        <>
            <GenericDeleteDetailsDropdownModal
                title={activePerson.name}
                description='Är du säker på att du vill radera denna person?'
                handleDelete={deletePerson}
            />
        </>
    );
};
export default PersonDetailsDropdownModal;
